import { Button } from "@mantine/core";

const MantineButton = (props: any) => {
  const { name, children, className, onClick, rightSection, style, color, variant, leftSection, onMouseEnter, justify ,disabled} = props;
  return (
    <Button type="submit" variant={variant} fullWidth className={className} onClick={onClick} leftSection={leftSection} rightSection={rightSection} style={style} color={color} onMouseEnter={onMouseEnter} justify={justify} disabled={disabled}>
      {name || children}
    </Button>
  );
};

export default MantineButton;
